import React, { useEffect, useState } from 'react';

interface InviteGateProps {
  storageKey: string;
  validCodes: string[];
  lang?: 'en' | 'es';
  children: React.ReactNode;
}

const COPY = {
  en: {
    eyebrow: 'Invite only',
    title: 'This page is private.',
    subtitle: 'Enter the invite code your iTOLLZ contact shared with you to continue.',
    placeholder: 'Invite code',
    submit: 'Enter',
    error: 'Invalid code. Please check with your iTOLLZ contact.',
    request: 'Need access? Email',
  },
  es: {
    eyebrow: 'Acceso por invitación',
    title: 'Esta página es privada.',
    subtitle: 'Ingresa el código de invitación que te compartió tu contacto de iTOLLZ para continuar.',
    placeholder: 'Código de invitación',
    submit: 'Entrar',
    error: 'Código inválido. Verifica con tu contacto de iTOLLZ.',
    request: '¿Necesitas acceso? Escribe a',
  },
};

const InviteGate: React.FC<InviteGateProps> = ({ storageKey, validCodes, lang = 'en', children }) => {
  const [unlocked, setUnlocked] = useState<boolean>(false);
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const t = COPY[lang];

  useEffect(() => {
    try {
      if (localStorage.getItem(storageKey) === '1') setUnlocked(true);
    } catch {}
  }, [storageKey]);

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const value = code.trim().toUpperCase();
    if (validCodes.map((c) => c.toUpperCase()).includes(value)) {
      try { localStorage.setItem(storageKey, '1'); } catch {}
      setError('');
      setUnlocked(true);
    } else {
      setError(t.error);
    }
  };

  if (unlocked) return <>{children}</>;

  return (
    <div
      style={{
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#0B1F3F',
        color: 'white',
        fontFamily: "'Geist', ui-sans-serif, system-ui, sans-serif",
        padding: '24px',
      }}
    >
      <div style={{ maxWidth: 440, width: '100%' }}>
        <p style={{ fontSize: 12, letterSpacing: '0.18em', fontWeight: 700, textTransform: 'uppercase', color: '#2563EB', margin: 0 }}>
          {t.eyebrow}
        </p>
        <h1 style={{ fontSize: 36, lineHeight: 1.1, fontWeight: 700, margin: '12px 0 12px', letterSpacing: '-0.02em' }}>
          {t.title}
        </h1>
        <p style={{ color: '#cbd5e1', fontSize: 16, lineHeight: 1.55, margin: '0 0 24px' }}>{t.subtitle}</p>
        <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <input
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder={t.placeholder}
            autoFocus
            autoComplete="off"
            style={{
              background: 'rgba(255,255,255,0.05)',
              border: '1px solid rgba(255,255,255,0.15)',
              borderRadius: 10,
              padding: '14px 16px',
              color: 'white',
              fontSize: 16,
              outline: 'none',
              letterSpacing: '0.04em',
              textTransform: 'uppercase',
            }}
          />
          {error && (
            <p style={{ color: '#FCA5A5', fontSize: 14, margin: 0 }}>{error}</p>
          )}
          <button
            type="submit"
            style={{
              background: '#2563EB',
              color: 'white',
              border: 'none',
              borderRadius: 10,
              padding: '14px 16px',
              fontSize: 15,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            {t.submit}
          </button>
        </form>
        <p style={{ marginTop: 20, fontSize: 13, color: '#94a3b8' }}>
          {t.request} <a href="mailto:hello@itollz.com" style={{ color: '#93C5FD' }}>hello@itollz.com</a>
        </p>
      </div>
    </div>
  );
};

export default InviteGate;
